import { createGlobalStyle } from "styled-components";

export const HiveUiWidgetGlobalStyle = createGlobalStyle`
    .hive-modal {
        .hui-modal-heading {
            font-size: 100%;
            font-family: "Mulish", "Inter", sans-serif;
        }
        .btn-lg, .btn-group-lg>.btn {
            padding: 12px 16px;
            font-size: 100%;
            border-radius: 8px;
        }
        .btn {
            font-family: "Mulish", "Inter", sans-serif;
            font-size: 100%;
        }
        .btn-primary {
            box-shadow: 0 2px 4px 0 rgba(40, 44, 46, .12), 0 2px 2px 0 rgba(255, 255, 255, .4) inset;
            background-color: #0c59bc;
            border-color: #001a5c;
        }
        .btn-primary:hover {
            background: linear-gradient(rgba(0, 0, 0, 0.168627451), rgba(0, 0, 0, 0.168627451)), #0c59bc;
        }

        .pg-font-body-s,
        .pg-font-label-m {
            font-family: "Mulish", "Inter", sans-serif;
            font-size: 100%;
        }
    }
`;
